const getLocationOrigin = () => {
  return window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '')
}

const companyName = '麻多多CRM'
const version = 'V11.1.1'
const baiduKey = '05ruDZ0vje9LRIkLhC29PWpFgoZdIUHh'

export default {
  version,
  companyName,
  getLocationOrigin,
  baiduKey
}
